import axios from "@/libs/api.request.js";

// const baseUrl = 'http://h5test.hzwxbz999.cn'
const baseUrl = 'http://h5.hzwxbz999.cn'

// 用户账号密码登陆
export const usersLogin = (data) => axios.request({
    url: `${baseUrl}/activity/authorize/username`,
    data,
    method: "post",
})

// 用户凭证登陆
export const usersInitLogin = (data) => axios.request({
    url: `${baseUrl}/activity/authorize/credential`,
    data,
    method: "post"
    , unHint: true
})

// 获取代金券活动详情
export const giftDetail = (params) => axios.request({
    url: `${baseUrl}/voucher-activity/info`,
    params,
    method: "get"
})

// 获取抽奖
export const drawResults = (data) => axios.request({
    url: `${baseUrl}/voucher-activity/draw`,
    data,
    method: "post"
})

// 抽奖记录
export const drawRecord = (data) => axios.request({
    url: `${baseUrl}/voucher-activity/record`,
    data,
    method: "post"
})

// 埋点上报
export const eventTrackApi = (data) => axios.request({url: `${baseUrl}/noncore/event-track`, data, method: "post"});
